import React from 'react';

import { MetricProgressBarCard } from '../metricProgressBarCard/MetricProgressBarCard';
import { isTieredScorecard } from '../../utils/metricAttainment';
import './metricGreetingCard.scss';

type metricProps = {
    employeeName: string;
    isSpervisor?: boolean;
    totalMetricsAttained: number;
    totalMetricsReported: number;
    totalMetricsTargeted: number;
    // P4P multi-tier (E20-6317): MetricProgressBarCard's count-based "X of Y metrics" progress
    // doesn't apply to the tiered payout model (per-metric blended rate, not a simple count), so
    // it's hidden entirely for a tiered scorecard rather than shown with misleading numbers.
    scorecardCalculationRuleId?: number | null;
};

export const MetricGreetingCard = ({
    employeeName,
    isSpervisor = false,
    totalMetricsAttained, totalMetricsReported, totalMetricsTargeted,
    scorecardCalculationRuleId,
}: metricProps) => {
    const hideProgressBar = isSpervisor || isTieredScorecard(scorecardCalculationRuleId);
    return (
        <div className="card ms-4 me-4 shadow bg-body rounded border-0">
            <div className="card-body p-0 pe-5 ps-4">
                <div className="row">
                    <div className="col-md-6">
                       {hideProgressBar ? (<span id="label_employeename" className="mt-3 mb-3 d-inline-block">
                            {!employeeName ? 'loading..' : `Hello ${employeeName}!`}
                        </span>)
                        :
                        (<span id="label_employeename" className="mt-4 pt-1 ms-3 d-inline-block" >
                            {!employeeName ? 'loading..' : `Hello ${employeeName}!`}
                        </span>)}
                    </div>
                    {hideProgressBar ? (
                        ''
                    ) : (
                        <MetricProgressBarCard
                            totalMetricsAttained={totalMetricsAttained}
                            totalMetricsReported={totalMetricsReported}
                            totalMetricsTargeted={totalMetricsTargeted}
                        />
                    )}
                </div>
            </div>
        </div>
    );
};
